<template>
	<k-menu class="ks-label-color-picker" :right="right" :left="left" :disabled="disabled">
		<template #activator>
			<slot name="activator" :value="value" :color="selected_color">
				<k-btn no-margin :size="size" icon :icon-name="icon" :disabled="disabled" v-tooltip.bottom="tooltip"></k-btn>
			</slot>
		</template>
		<template #default>
			<div class="ks-label-color-picker-palette" :style="{ 'grid-template-columns': 'repeat(' + columns + ', 22px)' }">
				<div
					v-for="c in colors"
					:key="c.value"
					class="ks-label-color-picker-swatch"
					:class="{ 'ks-label-color-picker-swatch-selected': c.value === value }"
					:style="{ background: c.color || 'transparent' }"
					v-tooltip.bottom="c.title"
					@click="select(c.value)"
				>
					<k-icon v-if="!c.color" small>block</k-icon>
				</div>
			</div>
		</template>
	</k-menu>
</template>

<script>
import { TILE_COLORS } from '@/models/monitor.js';

export default {
	props: {
		// Selected color value (v-model)
		"value": {
			type: String,
			default: ""
		},
		// [{ value, title, color }]; an item with an empty color is shown as "no color"
		"colors": {
			type: Array,
			default: function() { return TILE_COLORS }
		},
		"columns": {
			type: Number,
			default: 7
		},
		"icon": {
			type: String,
			default: "palette"
		},
		"size": {
			type: String,
			default: "xs"
		},
		"tooltip": {
			type: String,
			default: "Color"
		},
		"disabled": {
			type: Boolean,
			default: false
		},
		"right": {
			type: Boolean,
			default: false
		},
		"left": {
			type: Boolean,
			default: false
		}
	},
	computed: {
		selected_color() {
			var c = this.colors.find(c => c.value === this.value);
			return c ? c.color : "";
		}
	},
	methods: {
		select(value) {
			if (value === this.value) return;
			this.$emit("input", value);
		}
	}
}
</script>

<style>
	.ks-label-color-picker {
		display: inline-block;
	}
	.ks-label-color-picker-palette {
		display: grid;
		gap: 6px;
		padding: 8px;
	}
	.ks-label-color-picker-swatch {
		width: 22px;
		height: 22px;
		border-radius: 4px;
		border: 1px solid var(--ks-col-secondary);
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		color: var(--ks-font-color-secondary);
	}
	.ks-label-color-picker-swatch-selected {
		outline: 2px solid var(--ks-font-color-primary);
		outline-offset: 1px;
	}
</style>
